<template>
  <div class="discuss-list">
    <div class="item-icon">
      <img :src="userImg" alt="">
    </div>
    <div class="item-msg">
      {{listData.commentUserNickname}}：{{listData.content}}
    </div>
  </div>
</template>
<script>
import { getTimer, format } from "@/utils/timer.js";
export default {
  data() {
    return {
      userImg: require("@/assets/user.png"),
    }
  },
  props: {
    listData: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    timeFormate(val) {
      if (val) {
        return getTimer(format(val, "yyyy-MM-dd hh:mm:ss"));
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.discuss-list {
  min-height: 80px;
  box-sizing: border-box;
  padding:0 0;
  line-height: 44px;
  margin-top: 15px;
  display: flex;
  align-items: top;
  .item-icon{
    width: 48px;
    img{
      width: 48px;
      height: 48px;
    }
  }
  .item-msg{
    width: 626px;
    margin-left: 16px;
    font-size: 28px;
    color: rgb(68, 68, 68);
    padding-top: 10px;

  }

}
</style>
